import React from "react";
import Deadlines from "../deadlines/deadlines";
import "./footer.css";
import { Goback } from "../nav/nav";
import { blogvisible } from "../main/main";

function Footer(props) {
  return (
    <div className="footer">
      <div style={{ marginBottom: "clamp(5px,0.5vh,10px)" }}>
        <span
          onClick={() => {
            blogvisible("open");
          }}
        >
          Blog
        </span>
        {/* <i class="bi bi-dot dot"></i>
        <span>Case Study</span> */}
        <i className="bi bi-dot dot"></i>
        <span onClick={props.onVideosOpen}>Video</span>
        <i className="bi bi-dot dot"></i>
        <span onClick={props.onFormsOpen}>Form</span>
        <i className="bi bi-dot dot"></i>
        <span onClick={props.onCalculatorOpen}>Calculator</span>
      </div>
      <Deadlines />
      <div className="icons">
        <a target="_self" rel="noopener noreferrer" href={`tel: +919292300345`}>
          {" "}
          <i className="mx-1 fa fa-phone"></i>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={
            "https://api.whatsapp.com/send/?phone=9292300345&text&app_absent=0"
          }
        >
          {" "}
          <i className="mx-1 fa fa-whatsapp"></i>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`https://telegram.me/make05`}
        >
          {" "}
          <i className="mx-1 fa fa-telegram"></i>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={
            "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=samskrithigoshala@gmail.com"
          }
        >
          {" "}
          <i className="mx-1 fa fa-envelope"></i>
        </a>
        {props.goback && <Goback />}
      </div>
    </div>
  );
}
export default Footer;
